<template>
  <div class="container-fluid container-with-vertical-nav full-height cards-pf">
    <div v-if="$apollo.loading">
      <div style="margin-top: 10%;" class="text-center">
        <div class="spinner" />
        <strong>กำลังโหลด..</strong>
      </div>
    </div>
    <div v-else>
      <div class="row toolbar-pf row-toolbar-on-cards-page">
        <div class="col-sm-12">
          <div class="toolbar-pf-actions toolbar-page-header">
            <div>
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <router-link tag="a" :to="{ name: 'settings.osda-users.index' }">
                    บัญชีเจ้าหน้าที่ OSDA
                  </router-link>
                </li>
                <li class="breadcrumb-item active">แสดงข้อมูลบัญชี</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-cards-pf">
        <div class="col-xs-12">
          <div class="card-pf">
            <div class="card-pf-heading">
              <h2 class="card-pf-title">
                แสดงข้อมูลบัญชี
                <button class="btn btn-default pull-right" @click="deleteAccount()">
                  ลบบัญชี
                </button>
              </h2>
            </div>
            <div class="card-pf-body">
              <dl class="dl-horizontal">
                <dt>ชื่อ</dt>
                <dd>{{ user.firstName }}</dd>
                <dt>นามสกุล</dt>
                <dd>{{ user.lastName }}</dd>
                <dt>ชื่อผู้ใช้ (Username)</dt>
                <dd>{{ user.uid }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
export default {
  apollo: {
    user: {
      query: gql`query user($id: ID!) {
        user(_id: $id) {
          uid
          firstName
          lastName
        }
      }`,
      variables () {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  data () {
    return {
      studentId: ''
    }
  },
  methods: {
    async deleteAccount () {
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!) {
          deleteUser(_id: $id)
        }`,
        variables: {
          id: this.$route.params.id
        }
      })

      this.$router.push({ name: 'settings.osda-users.index' })
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/js/views/settings/osda_user/Show.vue